import type { LinkApiService, PublicApiService } from "api";
import React, { createContext, useContext } from "react";

export interface UninitialisedContext<T> {
  context: React.Context<T | undefined>;
  useVal: () => T;
}

const makeUninitialisedContext = <T>(name: string): UninitialisedContext<T> => {
  const context = createContext<T | undefined>(undefined);

  const useVal = (): T => {
    const s = useContext(context);

    if (s === undefined) {
      throw new Error(`Context ${name} must be initialised before use`);
    }

    return s;
  };

  return { context, useVal };
};

export const { context: PublicApiServiceContext, useVal: usePublicApiService } =
  makeUninitialisedContext<PublicApiService>("PublicApiService");

export const { context: LinkApiServiceContext, useVal: useLinkApiService } =
  makeUninitialisedContext<LinkApiService>("LinkApiService");
